import React, { useEffect, useState } from "react";
import SumsubWebSdk from "@sumsub/websdk-react";
import { getSumsubToken } from "../services/apiService";
import { useActiveAccount, useActiveWalletChain } from "thirdweb/react";

const SumsubVerification = () => {
    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();

    useEffect(() => {
        if (add && add.address && chain) {
            setAddress(add.address);

        }
    }, [add, chain]);

    const [token, setToken] = useState("");
    const [tab, setTab] = useState('pending');
    const [, setShowRefreshButton] = useState(false);

    useEffect(() => {
        if (address) {

            getSumsubToken(address).then((res) => {
                if (res?.data?.token) {
                    setToken(res.data.token);
                }
            });
        }
    }, [address]);

    return (
        <div className="w-full max-w-[720px] flex flex-col gap-4">
            <div className="flex flex-col items-center text-center gap-2">
                <p className="text-[11px] font-semibold text-usdx-accent uppercase tracking-[0.18em]">
                    Verification
                </p>
                <h1 className="text-[22px] sm:text-[26px] font-bold text-usdx-ink leading-tight">
                    Complete your <span className="gradient-text">Identity Check</span>
                </h1>
            </div>

            {/* Opaque plane: the Sumsub SDK styles its own surfaces and reads
                poorly over the translucent glass fill. */}
            <div className="card-3d bg-usdx-surface p-4 sm:p-6 text-center overflow-hidden">
            {
                tab === "Completed" ?
                    <>
                        <h3 className="text-[18px] font-bold text-usdx-success-strong py-8">
                            Your KYC is Completed
                        </h3>
                    </>
                    :
                    token ? (
                        <>
                            <SumsubWebSdk
                                accessToken={token}
                                expirationHandler={() => Promise.resolve(token)}
                                config={{
                                    lang: "en-EN",
                                    i18n: {
                                        document: {
                                            subTitles: {
                                                IDENTITY: "Upload a document that proves your identity",
                                            },
                                        },
                                    },
                                    onError: (error) => {
                                        console.error("WebSDK onError", error);
                                    },
                                }}
                                options={{ addViewportTag: false, adaptIframeHeight: true }}
                                onMessage={(type, payload) => {
                                    console.log("Sumsub message:", type, payload);

                                    if (
                                        type === "idCheck.onApplicantStatusChanged" &&
                                        payload?.reviewResult?.reviewAnswer === "GREEN"
                                    ) {

                                        console.log("Verification completed successfully");
                                        setTab("Completed")
                                        // navigate("/");
                                    } else {
                                        setShowRefreshButton(true);
                                    }
                                }}
                                onError={(data) => console.log("onError", data)}
                            />

                            {/* Refresh Button Rendered Conditionally */}
                            {/* {showRefreshButton && (
                        <button
                            onClick={() => navigate("/dashboard")}
                            style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                borderRadius: "5px",
                                backgroundColor: "#215C98",
                                color: "white",
                                cursor: "pointer",
                                border: "none",
                                position: 'absolute',
                                top: 0,
                                right: 20,
                            }}
                        >
                            Go To Dashboard
                        </button>
                    )} */}
                        </>
                    ) : (
                        <h3 className="text-[16px] font-semibold text-usdx-ink-muted py-10">
                            Loading…
                        </h3>
                    )}
            </div>
        </div>
    );
};

export default SumsubVerification;